<template>
  <div>
    <a-modal
      wrapClassName="fullpage-model"
      :visible="visibleValue"
      :title="null"
      :footer="null"
      @ok="handleOk"
      :closable="false"
      @cancel="handleCancel"
    >
      <div class="close-btn">
        <i @click="handleCancel" class="iconfont icon-close"></i>
      </div>
      <slot></slot>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(val) {
      this.visibleValue = val;
    }
  },
  data() {
    return {
      visibleValue: false
    };
  },
  mounted() {
    this.visibleValue = this.visible;
  },
  methods: {
    handleOk() {
      this.$emit("ok");
    },
    handleCancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>